import * as React from "react";
import { SectionHeader } from "../SharedComponents";
import { TextBoxEditor } from "../../../../../../../react-core/Html/TextBoxEditor";
import { PhoneNumberDetails } from "../../../Common/ClientDetails/PhoneNumberDetails";
import { Email } from "../../../../../../../react-core/Html/Validation/RegExPatterns";
import { ValidatorContents } from "../../../../../Common/ValidatorHelper";
import { Prospect } from "../../../../../../../Wrap/Models/Models/Customer/Prospect";
import { validationMessage } from "../../Resource/Validation";
import { titleLabels } from "../../Resource/Contents";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { CustomerType } from "../../../../../../../Wrap/Constants/Enums/Customer/CustomerType";

interface IContactDetailProps extends IProcessComponentProps {
    data: Prospect;
    customerType?: CustomerType;
}

interface IContactDetailState {}

export class ContactDetail extends ProcessComponent<IContactDetailProps, IContactDetailState> {
    render() {
        const { data, customerType } = this.props;

        return (
            <>
                {SectionHeader("Contact preference")}
                <div className="row">
                    <div className="col-fluid col-max-430">
                        <TextBoxEditor
                            value={data.EmailAddress}
                            label={titleLabels.emailLabel}
                            inputMode={"email"}
                            required={!(customerType === CustomerType.Child) ? validationMessage.emailValidation : ""}
                            regex={{ errorMessage: ValidatorContents.InvalidEmail, value: Email }}
                            onBlur={(value) => {
                                this.props.onChange({ EmailAddress: value });
                            }}
                            alwaysValidateOnUpdate={false}
                        />
                    </div>
                </div>
                <PhoneNumberDetails
                    data={data.PhoneNumbers}
                    onChange={(value) => {
                        this.props.onChange({ PhoneNumbers: value });
                    }}
                    onRef={(ref) => this.appendChild(ref)}
                />
            </>
        );
    }
}
